/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, Fragment } from "react";
import Answers from "./Answers";
import { withRouter } from "react-router-dom";
import { ExamTimeTypes, ExamTime } from "../../Functions";

const EndedExam = (props) => {
    const [state, setState] = useState({
        exam_id: null,
        exam_time: 0,
        questions: [],
        activeQuestion: 0,
        lockMode: false,
        errorPopup: { active: 0, text: "خطایی در سرور وجود دارد", status: null },
    });
    const [examDetail, setExamDetail] = useState();
    useEffect(() => {
        const data = localStorage.getItem("lastExam");
        const lastExam = JSON.parse(data);
        props.location.state &&
            setState({
                ...state,
                exam_id: props.location.state.exam_id,
                // exam_time: parseInt(localStorage.getItem('examTimeLeft') || props.location.state.exam_time),
                exam_time: ExamTime(
                    ExamTimeTypes.decrypt,
                    localStorage.getItem("examTimeLeft")
                ),
                questions: props.location.state.questions,
            });
        lastExam && setExamDetail(lastExam);
    }, []);
 
    useEffect(() => {
        const data = localStorage.getItem("lastExam");
        const lastExam = JSON.parse(data);
        props.location.state &&
            setState({
                ...state,
                exam_id: props.location.state.exam_id,
                exam_time: ExamTime(
                    ExamTimeTypes.decrypt,
                    localStorage.getItem("examTimeLeft")
                ),
                questions: props.location.state.questions,
            });
        lastExam && setExamDetail(lastExam);
    }, []);
    return (
        <Fragment>
            <div className="ExamPage col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="exam-container contain col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="exam">
                        <div className="exam-img">
                            <img
                                alt="img-exam"
                            src={
                                examDetail?.pic ? examDetail?.pic : "/img/archive-book.png"
                            }
                            />
                        </div>
                        <span className="exam-title">پاسخنامه آزمون {examDetail?.title}</span>
                        <div className="exam-detail info" style={{display:"flex",alignItems:"center !important"}}>
                            <span>
                                {examDetail?.is_exam_active === "active" &&
                                    examDetail?.start_date === null &&
                                    examDetail?.stop_date === null
                                    ? null
                                    : examDetail?.is_exam_active === "inactive" &&
                                        examDetail?.start_date &&
                                        examDetail?.stop_date !== null
                                        ? examDetail?.start_date
                                        : examDetail?.is_exam_active === "inactive" &&
                                            examDetail?.start_date === null &&
                                            examDetail?.stop_date === null
                                            ? "وقت این ازمون به اتمام رسیده است"
                                            : examDetail?.is_exam_active === "inactive" &&
                                                examDetail?.start_date === null &&
                                                examDetail?.stop_date !== null
                                                ? examDetail?.stop_date
                                                : examDetail?.is_exam_active === "inactive" &&
                                                    examDetail?.start_date !== null &&
                                                    examDetail?.stop_date === null
                                                    ? examDetail?.start_date
                                                    : null}
                            </span>

                            <button disabled={true}> به پایان رسیده</button>
                        </div>
                    </div>
                    <div className="ExamPage_wrapper">
                        
                        {state.questions.map((question) => (
                            <>
                            <div className="exam-question">
                                {question?.pic ? (
                                    <img
                                        src={question?.pic}
                                        alt="exam-img"
                                    />
                                ) : null}

                                <p className="exam_question">
                                    {state.questions.length > 0
                                        ? `${question.description} `
                                        : null}
                                </p>

                                {question?.right_answers > 1 ? (
                                    <span className="exam-cout">(بیش از یک مورد)</span>
                                ) : null}
                            </div>
                            <Answers
                                answers={
                                    state.questions.length > 0
                                        ? question.answers
                                        : []
                                }
                                    answer={question.type === "DESCRIPTIVE" ? question.descriptive_answer : question.right_answers}
                                // handleSelect={(id) => handleSelect(id)}
                            />
</>

                        ))}
                        {/* {state.questions.length > 0 && (
                            <div className="prev_next_buttons col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                {state.activeQuestion > 0 && (
                                    <ActionButton
                                        WhiteMode={true}
                                        OnLoadMode={false}
                                        DisableMode={state.lockMode || buttonLoader ? true : false}
                                        ClassNames={["prevOrNext_option", "prev"]}
                                        DisableOnLoadMode={false}
                                        Text={"قبلی"}
                                        DoAction={() => handlePrevPage()}
                                        Type={false}
                                    />
                                )}
                                <ActionButton
                                    WhiteMode={false}
                                    OnLoadMode={buttonLoader ? true : false}
                                    DisableMode={state.lockMode ? true : false}
                                    ClassNames={["prevOrNext_option", "next"]}
                                    DisableOnLoadMode={state.lockMode ? false : true}
                                    Text={
                                        state.questions.length === state.activeQuestion + 1
                                            ? "ثبت و پایان"
                                            : "بعدی"
                                    }
                                    DoAction={() =>
                                        handleNextPage(
                                            state.questions.length === state.activeQuestion + 1
                                                ? true
                                                : false
                                        )
                                    }
                                    Type={false}
                                />
                            </div>
                        )} */}
                        {/* <p
                            className={`textAlert Transition_All_5ms${state.lockMode || textAlert.active ? " active" : ""
                                }`}
                            style={{ color: state.lockMode ? "#ff1300" : textAlert.color }}
                        >
                            <i
                                className={
                                    state.lockMode ? "icon-exclamation-mark" : textAlert.icon
                                }
                            />
                            {state.lockMode ? "وقت آزمون به پایان رسید" : textAlert.text}
                        </p> */}
                    </div>
                    {/* <Popup active={state.errorPopup.active} class="box-exam_error">
                        <div className="error_box-exam">
                            <strong> خطا کد ({state.errorPopup.status})</strong>
                            <h4>{state.errorPopup.text}</h4>
                            <Button
                                variant="contained"
                                onClick={() => props.history.push("/")}
                            >
                                خروج
                            </Button>
                        </div>
                    </Popup> */}
                </div>
            </div>
        </Fragment>
    );
};

export default withRouter(EndedExam);
